
export const getProductPriceForDay = (product, date) => {
  const referenceDate = date ? new Date(date) : new Date();
  const dayOfWeek = referenceDate.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
  if (product.salePrices && product.salePrices[dayOfWeek] && product.salePrices[dayOfWeek].price) {
    return {
      finalPrice: product.salePrices[dayOfWeek].price,
      originalPrice: product.price,
      extraDiscount: product.salePrices[dayOfWeek].extraDiscount,
    };
  }
  return {
    finalPrice: product.price,
    originalPrice: null,
    extraDiscount: null,
  };
};
